import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class MyHeaderBaseComponent extends BaseComponent {
  public text: string = "MyHeader";

  constructor(public userService: UserService) {
    super(userService);
  }
}
